import type { Questionnaire } from '@medplum/fhirtypes'
import {
  VALIDATED_TOOL_SUMMARY_ITEM,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'
import { QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL } from '#src/structureDefinitions.ts'

export const mocaQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/MoCA',
  title: 'Montreal Cognitive Assessment [MoCA]',
  name: 'MoCA',
  status: 'active',
  subjectType: ['Patient'],
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  code: [
    {
      system: 'http://loinc.org',
      code: '72133-2',
      display: 'Montreal Cognitive Assessment [MoCA]',
    },
  ],
  item: [
    {
      linkId: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
      type: 'display',
      extension: [
        {
          url: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
          valueString:
            'https://geriatrictoolkit.missouri.edu/cog/MoCA-8.3-English-Test-2018-04.pdf',
        },
      ],
    },
    {
      type: 'integer',
      linkId: '/moca-visuospatial',
      text: 'Visuospatial / Executive',
    },
    {
      type: 'integer',
      linkId: '/moca-naming',
      text: 'Naming',
    },
    {
      type: 'integer',
      linkId: '/moca-attention',
      text: 'Attention',
    },
    {
      type: 'integer',
      linkId: '/moca-language',
      text: 'Language',
    },
    {
      type: 'integer',
      linkId: '/moca-abstraction',
      text: 'Abstraction',
    },
    {
      type: 'integer',
      linkId: '/moca-delayed-recall',
      text: 'Delayed Recall',
    },
    {
      type: 'integer',
      linkId: '/moca-orientation',
      text: 'Orientation',
    },
    {
      type: 'boolean',
      linkId: '/moca-education-adjustment',
      text: 'Education ≤12 years (+1 point)',
    },
    {
      type: 'integer',
      linkId: '/moca-mis',
      text: 'Memory Index Score (MIS)',
    },
    {
      type: 'decimal',
      code: [
        {
          code: '72133-2',
          display: 'Total score',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-unit',
          valueCoding: {
            code: '{score}',
            display: '{score}',
            system: 'http://unitsofmeasure.org',
          },
        },
      ],
      linkId: '/72133-2',
      text: 'Total score',
    },
    VALIDATED_TOOL_SUMMARY_ITEM,
  ],
} satisfies Questionnaire
